"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var credentials_storage_1 = tslib_1.__importStar(require("./credentials-storage"));
var Authentication = (function () {
    function Authentication(storageType, sdk) {
        var _this = this;
        this.tryToLoginFromCache = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var token, region, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = this.storage.getItem(credentials_storage_1.StorageItems.TOKEN);
                        if (!token) return [3, 4];
                        region = this.storage.getItem(credentials_storage_1.StorageItems.REGION);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.sdk.loginWithAuthToken(region, token)];
                    case 2:
                        _a.sent();
                        return [2, true];
                    case 3:
                        e_1 = _a.sent();
                        this.clearCredentials();
                        return [2, false];
                    case 4: return [2, false];
                }
            });
        }); };
        this.storage = new credentials_storage_1.default(storageType);
        this.sdk = sdk;
    }
    Authentication.prototype.storeCredentials = function (token, region, language) {
        this.storage.setItem(credentials_storage_1.StorageItems.TOKEN, token);
        this.storage.setItem(credentials_storage_1.StorageItems.REGION, region);
        this.storage.setItem(credentials_storage_1.StorageItems.LANGUAGE, language);
    };
    Authentication.prototype.clearCredentials = function () {
        this.storage.clearItem(credentials_storage_1.StorageItems.REGION);
        this.storage.clearItem(credentials_storage_1.StorageItems.TOKEN);
        this.storage.clearItem(credentials_storage_1.StorageItems.LANGUAGE);
    };
    Authentication.prototype.getCredentials = function (item) {
        return this.storage.getItem(item);
    };
    Authentication.prototype.attemptToLogin = function (email, password, selectedMerchant, captcha) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, sdk;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.sdk.loginWithEmail(email, password, selectedMerchant, captcha)];
                    case 1:
                        response = _a.sent();
                        if (response.success) {
                            sdk = response.data;
                            this.storeCredentials(sdk.session.user.authentication_token, sdk.session.region, sdk.session.user.language);
                        }
                        return [2, response];
                }
            });
        });
    };
    return Authentication;
}());
exports.default = Authentication;
//# sourceMappingURL=authentication.js.map